import React from 'react'
import { useField, FieldHookConfig } from 'formik'

import ErrorMessage from '@/components/formik/messages/ErrorMessage'
import TextInput, { TextInputProps } from '@/components/ui/inputs/TextInput'

type TextFieldProps = FieldHookConfig<string> & TextInputProps

const MemoizedTextInput = React.memo<TextInputProps>(TextInput)

export default function TextField(props: TextFieldProps) {
  const [field, meta] = useField<string>(props)

  const hasError = !!meta.error && meta.touched
  const errorId = hasError ? `${field.name}-error` : undefined

  return (
    <MemoizedTextInput
      autoComplete="off"
      {...props}
      error={hasError}
      helperText={hasError && <ErrorMessage error={meta.error} />}
      inputProps={{
        ...props.inputProps,
        'aria-invalid': hasError,
        'aria-describedby': errorId,
      }}
      FormHelperTextProps={{ ...props.FormHelperTextProps, id: errorId }}
      onBlur={field.onBlur}
      onChange={field.onChange}
      value={field.value ?? ''}
      {...props}
    />
  )
}
